
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("cO27o", function(module, exports) {
const $952bcc355421a8da$var$headerSearches = document.querySelectorAll(".m-header-search");
const $952bcc355421a8da$var$mainOverlay = document.querySelector(".c-overlay-main");
const $952bcc355421a8da$var$openers = document.querySelectorAll(".--js--main-search-opener");
const $952bcc355421a8da$var$closers = document.querySelectorAll(".--js-main-search-closer");
$952bcc355421a8da$var$headerSearches.forEach((headerSearch)=>{
    const open = ()=>{
        headerSearch.classList.add("--open");
        $952bcc355421a8da$var$mainOverlay?.classList.add("--show");
    };
    const close = ()=>{
        headerSearch.classList.remove("--open");
        $952bcc355421a8da$var$mainOverlay?.classList.remove("--show");
    };
    $952bcc355421a8da$var$openers.forEach((opener)=>opener.addEventListener("click", open));
    $952bcc355421a8da$var$closers.forEach((closer)=>closer.addEventListener("click", close));
});

});


//# sourceMappingURL=main-header-search.b956c9bb.js.map
